import { ArnConditionService } from './ArnConditionService';
import { ArnConditionContext } from './ArnConditionContext';
import { ArnContextualizable } from '../ArnContextualizable';

/**
 * A specialized, convenience condition service that relies on the basic condition service.
 */
export class ArnDelegateConditionService
  implements ArnContextualizable<ArnConditionContext>
{
  constructor(protected condition: ArnConditionService) {}

  inContext(context: ArnConditionContext | undefined): this {
    this.condition.inContext(context);
    return this;
  }

  get context(): ArnConditionContext | undefined {
    return this.condition.context;
  }
}
